var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableTennis({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#CC2525",
    d: "M8.015 7.932c.425.216.605.53.853.952.114.194.204.405.265.633l.469 1.75a2.536 2.536 0 0 1-1.793 3.105l-1.487.398c-1.836.492-3.709-.489-4.2-2.325 1.27.758 3.324.47 4.422-.89.975-1.209 1.827-2.636 1.47-3.623z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#509CF2",
    d: "M4.897 4.75l1.536.96a2.536 2.536 0 0 1 .807 3.494l-.816 1.306A3.441 3.441 0 0 1 .069 8.883 1.372 1.372 0 1 0 .813 6.5l.59-.944a2.536 2.536 0 0 1 3.494-.807z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.987,
    cy: 7.862,
    r: 1.185,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6DA9B",
    d: "M7.925.103c.547.15 1.021.43 1.37.929L6.948 4.457c-.315.746.06 1.002.222 1.221L4.712 4.143c.404.059.782-.098 1.065-.423L7.925.103zm6.438 7.66c.316.471.49.993.426 1.6l-4.02 1.044c-.727.356-.612.795-.633 1.067l-.848-2.771c.267.31.654.44 1.082.38l3.993-1.32z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableTennis);
export default __webpack_public_path__ + "static/media/table_tennis.f3ae9aff8acd9785330797c312ecaf45.svg";
export { ForwardRef as ReactComponent };